import PropTypes from 'prop-types'
import TrackVisibility from 'react-on-screen'

const BackgroundImage = ({ src, style, className, isVisible }) => {
  const bgImage = isVisible ? `url(${src})` : 'none'

  return (
    <div style={{ backgroundImage: bgImage, ...style }} className={className} />
  )
}

BackgroundImage.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
  // Injected by TrackVisibility
  isVisible: PropTypes.bool,
}

BackgroundImage.defaultProps = {
  style: {},
  className: '',
  isVisible: false,
}

const LazyBackgroundImage = ({ src, style, className }) => (
  <TrackVisibility offset={200} once>
    <BackgroundImage src={src} style={style} className={className} />
  </TrackVisibility>
)

LazyBackgroundImage.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
}

LazyBackgroundImage.defaultProps = BackgroundImage.defaultProps

export default LazyBackgroundImage
